import { clsx } from 'clsx';
import { FC } from 'react';

import { unstable_useId as useId } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@o2/ui/Box';
import FormControl from '@o2/ui/FormControl';
import InputLabel from '@o2/ui/InputLabel';
import MenuItem, { MenuItemProps } from '@o2/ui/MenuItem';
import Select, { SelectProps } from '@o2/ui/Select';
import Typography from '@o2/ui/Typography';

import { useSubheaderUtilityClasses } from '../subheaderClasses';

type SelectFilterProps = SelectProps & {
  options: { label: string; value: MenuItemProps['value']; internal?: boolean }[];
};

const StyledFormControl = styled(FormControl)(() => ({
  marginTop: '2px',
  '& .MuiSelect-select': {
    paddingTop: '2px',
    paddingBottom: '2px',
  },
}));

const SelectFilter: FC<SelectFilterProps> = ({ label, options, ...other }) => {
  const id = useId();
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.only('xs'));
  const utilityClasses = useSubheaderUtilityClasses();

  return (
    <Box display={xs ? 'flex' : undefined}>
      <StyledFormControl variant="standard" sx={{ flexGrow: 1 }} className={clsx(utilityClasses.select)}>
        {label && <InputLabel id={id}>{label}</InputLabel>}
        {/*@ts-expect-error ref FIXME*/}
        <Select
          labelId={id}
          label={label}
          fullWidth
          {...other}
          renderValue={(value) => (
            <Typography
              variant={mdDown ? (xs ? 'h4' : 'h3') : 'h5'}
              component="span"
              pl={0.5}
              whiteSpace="break-spaces"
              sx={{ boxDecorationBreak: 'clone' }}
            >
              {options.filter((opt) => opt.value === value)[0]?.label}
            </Typography>
          )}
        >
          {options.map(({ label, value, internal }) => (
            <MenuItem value={value} key={label} internal={internal}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    </Box>
  );
};

SelectFilter.displayName = 'Subheader.SelectFilter';

export default SelectFilter;
